/* eslint-disable react/jsx-no-literals */
import React from 'react'

function YouTubeMaintenaceIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="76"
      height="75"
      viewBox="0 0 76 75"
      {...props}
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_39"
            data-name="Rectangle 39"
            width="76"
            height="75"
            transform="translate(-0.438)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="YouTube" transform="translate(0.438)">
        <g id="Group_16" data-name="Group 16" clipPath="url(#clip-path)">
          <path
            id="Path_33"
            data-name="Path 33"
            d="M75.385,37.693A37.693,37.693,0,1,1,37.693,0,37.693,37.693,0,0,1,75.385,37.693"
            fill="#da0000"
          />
          <path
            id="Path_34"
            data-name="Path 34"
            d="M71.706,41.494a6.293,6.293,0,0,0-4.443-4.443C63.344,36,47.628,36,47.628,36s-15.716,0-19.635,1.05a6.293,6.293,0,0,0-4.443,4.443c-1.05,3.919-1.05,12.1-1.05,12.1s0,8.177,1.05,12.1a6.293,6.293,0,0,0,4.443,4.443c3.919,1.05,19.635,1.05,19.635,1.05s15.716,0,19.635-1.05a6.293,6.293,0,0,0,4.443-4.443c1.05-3.919,1.05-12.1,1.05-12.1s0-8.177-1.05-12.1M42.6,61.128V46.051L55.659,53.59Z"
            transform="translate(-9.936 -15.897)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  )
}

export default YouTubeMaintenaceIcon
